<template>
    <div class="detail-body">
        <div class="detail-top">
            <backindex :msg="detailMsg"></backindex>
        </div>
        <div class="see-comment">
            <textarea v-model="cmt" class="cmt-text" :placeholder="tips"></textarea>
            <div @click="feedback" class="read-btn">{{$t("submit")}}</div>
        </div>
        <div class="feed-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "cmtlist",
  components: {
    backindex,
    pagebottom
  },
  data() {
    return {
      detailMsg: "意见反馈",
      cmt: "",
      tips:"请输入您的宝贵意见",
    };
  },
  mounted:function(){
      this.detailMsg = this.$t("feedback");
      this.tips = this.$t("inputFeedback");
  },
  methods: {
    //添加评论
    feedback() {
      if (this.cmt != "") {
        this.req.feedback(this.cmt).then(res => {
          this.$toast({
            message: this.$t("feedbackSuccess"),
            duration: 3000
          });
          setTimeout(() => {
            this.go.goPersonal();
          }, 2000);
        });
      }
    }
  }
};
</script>

<style scoped>
.detail-body{
    width: 100%;
    height: auto;
    padding-top: 1.12rem;
}
.detail-top {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
}
.see-comment {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 0.8rem 0.4rem 0.4rem;
    box-sizing: border-box;
    overflow: hidden;
}
.comment-title {
    font-size: 0.3rem;
    line-height: 0.3rem;
    font-weight: 700;
    padding-bottom: 0.32rem;
}
.cmt-text {
    width: 100%;
    height: 3.2rem;
    padding: 0.18rem;
    border: 1px solid #ff1f4f;
    margin: 0 auto;
    box-sizing: border-box;
    border-radius: 0.08rem;
    outline: none;
    display: block;
    font-size: 0.26rem;
}
.read-btn{
    width: 100%;
    height: 0.76rem;
    border-radius: 0.08rem;
    font-size: 0.32rem;
    line-height: 0.76rem;
    text-align: center;
    box-sizing: border-box;
    font-weight: 700;
    background: #ff1f4f;
    color: #fff;
    margin-top: 0.4rem;
}
    .feed-bottom{
        width: 100%;
        height: auto;
        margin-top: 2em;
        left: 0;
        bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/feedback.vue